import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";
import { QA_LINK } from "../enums";
import { qaUnreadStore } from "../Stores/QAUnreadStore";

type SubMenus = "QUESTIONS" | "ADMIT" | "ACCEPT" | "ANSWER" | "APPROVE" | "APPROVE >" | "APPROVE >>" | "ALL";
export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "QA")?.children;
    const subModules = mainModuleChildren ? (mainModuleChildren.map((m) => m.module) as SubMenus[]) : null;

    if (subModules) {
      subModules.includes("QUESTIONS") &&
        config.push({
          label: <MenuItemWithBadge label={`Questions`} store={qaUnreadStore} prop={"questioner"} />,
          link: QA_LINK.QUESTIONS,
        });
      subModules.includes("ADMIT") &&
        config.push({
          label: <MenuItemWithBadge label={`Admit`} store={qaUnreadStore} prop={"bidderGatekeeper"} />,
          link: QA_LINK.ADMISSION,
        });
      subModules.includes("ACCEPT") &&
        config.push({
          label: <MenuItemWithBadge label={`Accept`} store={qaUnreadStore} prop={"generalGatekeeper"} />,
          link: QA_LINK.ACCEPT,
        });
      subModules.includes("ANSWER") &&
        config.push({
          label: <MenuItemWithBadge label={`Answer`} store={qaUnreadStore} prop={"specialist"} />,
          link: QA_LINK.ANSWER,
        });
      subModules.includes("APPROVE") &&
        config.push({
          label: <MenuItemWithBadge label={`Approve`} store={qaUnreadStore} prop={"categoryApproval"} />,
          link: QA_LINK.CAT_APPROVE,
        });
      subModules.includes("APPROVE >") &&
        config.push({
          label: <MenuItemWithBadge label={`Approve >`} store={qaUnreadStore} prop={"approvalStage_1"} />,
          link: QA_LINK.APPROVE_1,
        });
      subModules.includes("APPROVE >>") &&
        config.push({
          label: <MenuItemWithBadge label={`Approve >>`} store={qaUnreadStore} prop={"approvalStage_2"} />,
          link: QA_LINK.APPROVE_2,
        });
      subModules.includes("ALL") &&
        config.push({
          label: <MenuItemWithBadge label={`All`} />,
          link: QA_LINK.ALL_QUESTIONS,
        });
    }

    return config;
  },
};
